var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 57,
    viewBox: "0 0 58 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.865234,
    y: 0.598145,
    width: 56.4019,
    height: 56.4019,
    rx: 28.2009,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4781 38.1997C22.2748 38.1997 20.5973 37.3985 19.4456 35.7961C18.2939 34.1937 17.718 31.8902 17.718 28.8858C17.718 25.8813 18.2939 23.5778 19.4456 21.9754C20.5973 20.373 22.2748 19.5718 24.4781 19.5718C26.6814 19.5718 28.3589 20.373 29.5106 21.9754C30.6623 23.5778 31.2382 25.8813 31.2382 28.8858C31.2382 31.9153 30.6623 34.2187 29.5106 35.8211C28.3589 37.4235 26.6814 38.1997 24.4781 38.1997ZM24.4781 35.8712C27.1321 35.8712 28.4591 33.5427 28.4591 28.8858C28.4591 24.2288 27.1321 21.9003 24.4781 21.9003C21.8241 21.9003 20.5222 24.2288 20.5222 28.8858C20.5222 33.5427 21.8241 35.8712 24.4781 35.8712ZM37.8598 19.9724H40.013V37.7991H37.334V25.0801H33.2529V23.1021L33.6535 23.0771C34.9304 23.002 35.8819 22.7266 36.5328 22.2759C37.1838 21.8252 37.6094 21.0491 37.8598 19.9724Z",
    fill: "#6C6C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.714976ca042667a19a30ce06a565d6e9.svg";
export { ForwardRef as ReactComponent };